module.exports = {
  debug: process.env.NODE_ENV === 'development',

  siteName: 'Frontier',
  author: 'zeiq.co',
  description: 'Premium Products Shop',
  logo: '/images/logo.png',
  siteUrl: 'https://www.frontier.com/',
  graphQlUri: 'https://frontier-api.vercel.app/api',
  graphQlUriDev: 'https://frontier-api.vercel.app/api',
  projectKey: '123123abc',

  type: 'website',
  googleAnalytics: '',
  backgroundColor: '#FFFFFF',
  themeColor: '#F69736',
  sanityId: '5ltc4asc',
  razorPayKey: '',
  mailchimp: '',
};
